export default "__VITE_ASSET__eRksI3fz__"